import { useContext } from 'react'

import { PassContext } from './pass-context'

const normaliseUrl = url => typeof url === "string" && url.length ? url : null

const withCorsVariant = url => {
  if (!url) return url

  try {
    const parsed = new URL(url, window.location.href)
    parsed.searchParams.set("_cors", "1")
    return parsed.toString()
  }
  catch {
    const separator = url.includes("?") ? "&" : "?"
    return `${url}${separator}_cors=1`
  }
}

const PassImage = ({
  src,
  captureSrc,
  className,
  style,
  alt = "",
  onLoad,
  crossOrigin,
  ...rest
}) => {
  const { allowImageCors = false } = useContext(PassContext)
  const resolvedSrc = normaliseUrl(src)
  if (!resolvedSrc) return null
  const resolvedCrossOrigin = crossOrigin ?? (allowImageCors ? "anonymous" : null)
  const renderSrc = allowImageCors ? withCorsVariant(resolvedSrc) : resolvedSrc
  const resolvedCaptureSrc = normaliseUrl(captureSrc) ?? resolvedSrc
  const captureImageSrc = allowImageCors ? withCorsVariant(resolvedCaptureSrc) : resolvedCaptureSrc

  return (
    <img
      key={`${renderSrc}|${resolvedCrossOrigin ?? "none"}`}
      src={renderSrc}
      data-capture-src={captureImageSrc}
      crossOrigin={resolvedCrossOrigin}
      className={className}
      style={style}
      alt={alt}
      onLoad={onLoad}
      {...rest}
    />
  )
}

const PassBackgroundImage = ({
  src,
  className,
  style,
  children,
  ...rest
}) => {
  const { allowImageCors = false } = useContext(PassContext)
  const resolvedSrc = normaliseUrl(src)
  const renderSrc = allowImageCors ? withCorsVariant(resolvedSrc) : resolvedSrc

  return (
    <div
      className={className}
      style={{
        ...style,
        backgroundImage: renderSrc ? `url(${renderSrc})` : "none",
      }}
      data-capture-src={renderSrc ?? ""}
      {...rest}
    >
      {children}
    </div>
  )
}

export {
  PassImage,
  PassBackgroundImage,
}
